export default __webpack_public_path__ + "static/media/hourglass-outline-16px.673d2fc6.svg";